const checkboxMiddleware = (field) => {
  let checkboxProps = {};
  if (field.type === 'CHECKBOX') {
    checkboxProps = {
      children: 'Optional',
    };
  }
  return {
    ...field,
    checkboxProps,
  };
};

export const appearanceMiddleware = (field) => {
  return {
    ...field,
    disabled: true,
  };
};

export const Middlewares = [checkboxMiddleware, appearanceMiddleware];
